import { styled } from '@mui/material/styles';

const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.rootColor,
}));

const ReassignmentTooltip = ({
  allowInvestmentReassignment,
  isKiFundReassignmentDisabled,
  isFrozen,
  isTransfereeInvestment,
  isTransferorInvestment,
}: {
  allowInvestmentReassignment: boolean;
  isKiFundReassignmentDisabled: boolean;
  isFrozen: boolean;
  isTransfereeInvestment: boolean;
  isTransferorInvestment: boolean;
}) => {
  const contactUsText = (
    <>
      Please contact{' '}
      <StyledLink href="mailto:support@joinfurther.com">
        support@joinfurther.com
      </StyledLink>{' '}
      if you wish to transfer this subscription.
    </>
  );

  if (allowInvestmentReassignment) {
    return null;
  }

  if (isKiFundReassignmentDisabled) {
    return (
      <>
        EIS (KI) subscriptions can only be transferred before first allocation
        or after final allocation and EIS5 generation. {contactUsText}
      </>
    );
  }

  if (isTransfereeInvestment || isTransferorInvestment || isFrozen) {
    return (
      <>
        This subscription cannot be reassigned as it is either frozen, a
        transferor or a transferee subscription. {contactUsText}
      </>
    );
  }

  return null;
};

export default ReassignmentTooltip;
